import { useMemo } from "react";
import { useSelector } from "react-redux";

import {
    resolveSidebarNavSections,
    sidebarNavSections,
} from "../components/sidebarNavConfig";

export function useSidebarNavSections() {
    const isAuthenticated = useSelector((state) => Boolean(state.auth.user));

    return useMemo(
        () => resolveSidebarNavSections(sidebarNavSections, { isAuthenticated }),
        [isAuthenticated]
    );
}
